"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var breakpoints = _ref.breakpoints;
  return {
    contents: {},
    contentsDatasource: _defineProperty({
      backgroundColor: "rgba(255, 255, 255, 0.1)"
    }, breakpoints.up("md"), {
      background: "unset"
    }),
    datasource: {},
    datasourceContentType: {},
    datasourceDescription: {},
    datasourceIcon: {},
    datasourceLink: {},
    description: {},
    heading: {},
    highlight: {},
    subtitle: {},
    title: {}
  };
});
var _default = useStyles;
exports["default"] = _default;